import { render, staticRenderFns } from "./face-control.vue?vue&type=template&id=4c9d9757&scoped=true&"
import script from "./face-control.vue?vue&type=script&lang=ts&"
export * from "./face-control.vue?vue&type=script&lang=ts&"
import style0 from "./face-control.vue?vue&type=style&index=0&id=4c9d9757&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9d9757",
  null
  
)

export default component.exports